import { API } from 'api/config'
import {
	BodyCreateLocation,
	CreateLocationResponse,
	MessageResponseNewLocationLists,
	NewLocationListRequest
} from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils/sentry'
import { locationCreate } from './apiCreate'

export const postCreateLocation = async (
	organizationId: number,
	body: BodyCreateLocation
): Promise<CreateLocationResponse | null> => {
	let res = null as CreateLocationResponse | null
	await API()
		.post(`${locationCreate.CREATE}/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.LOCATION,
					event: SentryEvents.CREATE_LOCATION_ERROR,
					error,
					extra: {
						payload: body,
						organizationId
					}
				})
				const data = error.response?.data
				let detail = 'Failed to create location. Please try again.'
				if (data?.errors?.[0]?.msg) {
					detail = data.errors[0].msg
				} else if (typeof data?.detail === 'string') {
					detail = data.detail
				} else if (typeof data?.detail?.error === 'string') {
					detail = data.detail.error
				}
				res = { detail } as CreateLocationResponse
			}
		)
	return res
}

export const postNewLocationLists = async (
	organizationId: number,
	body: NewLocationListRequest
): Promise<MessageResponseNewLocationLists | null> => {
	let res = null as MessageResponseNewLocationLists | null
	await API()
		.post(`/location_list/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				res = { detail: error.response.data.detail }
			}
		)
	return res
}
